import { render } from "./ConfirmarDomicilioModal.vue?vue&type=template&id=67e3dec5"
import script from "./ConfirmarDomicilioModal.vue?vue&type=script&lang=js"
export * from "./ConfirmarDomicilioModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__